module.exports = __webpack_public_path__ + "static/media/q-fever-badge.f67db5ab.png";